// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import './Popup.module.scss';
// =========================

export default function Popup({
    children,
    style,
    translateY50,
}: {
    children: React.ReactNode;
    style?: {};
    translateY50?: boolean;
}) {
    return (
        <motion.div
            initial={
                translateY50
                    ? { opacity: 0, x: 50, y: '-50%' }
                    : { opacity: 0, x: 50 }
            }
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            styleName="popup"
            style={style}
        >
            {children}
        </motion.div>
    );
}
